import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { pageSearch as page, textSearch as text } from '@/shared/api/search'
import { requirePermission } from '@/shared/auth/guards'

const usersSearchSchema = z.object({
  page,
  sort: text,
  search: text,
  status: z.enum(['active', 'pending', 'inactive']).optional().catch(undefined),
  position: text,
  region: text,
  department: text,
  level: text,
  channel: text,
  company: text,
})

export const usersRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/users',
  beforeLoad: requirePermission('users.view'),
})

export const usersIndexRoute = createRoute({
  getParentRoute: () => usersRoute,
  path: '/',
  validateSearch: (search) => usersSearchSchema.parse(search),
  component: lazyRouteComponent(() => import('./pages/users-page'), 'UsersPage'),
})

// Rotas estáticas ("imports", "new") têm prioridade sobre "$userId".
export const userImportsRoute = createRoute({
  getParentRoute: () => usersRoute,
  path: 'imports',
  validateSearch: (search) => z.object({ page }).parse(search),
  component: lazyRouteComponent(() => import('./pages/user-imports-page'), 'UserImportsPage'),
})

export const userFormRoute = createRoute({
  getParentRoute: () => usersRoute,
  path: '$userId',
  component: lazyRouteComponent(() => import('./pages/user-form-page'), 'UserFormPage'),
})

export const usersRoutes = usersRoute.addChildren([usersIndexRoute, userImportsRoute, userFormRoute])
